<template>
  <div class="page">
    <div class="container-fluid">
      <div class="row py-3">
        <div class="col-2"><h2 class="">Checklist Projects</h2></div>
        <div class="col-1">

        </div>
        <div class="col-4">
          <b-form-radio-group class=""
                              id="btn-radios-type"
                              button-variant="outline-primary"
                              v-model="projectType"
                              buttons
                              size="sm">
            <b-form-radio :value="null">All</b-form-radio>
            <b-form-radio :value="'simple'">Simple</b-form-radio>
            <b-form-radio :value="'engineering'">Engineering</b-form-radio>
            <b-form-radio :value="'machining'">Machining</b-form-radio>
            <b-form-radio :value="'moldMaking'">Mold Making</b-form-radio>
          </b-form-radio-group>

          <b-form-radio-group class="float-right"
                              id="btn-radios-archived"
                              button-variant="outline-primary"
                              v-model="showArchived"
                              buttons
                              size="sm"
                              v-if="isAdmin">
            <b-form-radio :value="false">Active</b-form-radio>
            <b-form-radio :value="true">Archived</b-form-radio>
          </b-form-radio-group>
        </div>
        <div class="col-2">
          <b-form-input debounce="250" v-model="searchQuery" size="sm" placeholder="Project Name Filter"></b-form-input>
        </div>
        <div class="col-2">
          <b-button class="btn-add-project icon-btn float-right" variant="primary" size="sm" @click="newProject()">
            <PlusBoxIcon /> New Project
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-overlay :show="loading.projects" rounded="sm">
            <div class="card">
              <div class="card-body px-0">
                <div class="container-fluid" v-if="projects.length">
                  <div class="row">
                    <div class="col-3">
                      <div class="row">
                        <div class="col-3 text-center">Id</div>
                        <div class="col-3 text-center">Facility</div>
                        <div class="col-6 text-center">Type</div>
                      </div>
                    </div>
                    <div class="col-6">Project Name</div>
                    <div class="col">
                      <div class="row">
                        <div class="col-3 text-center"># Issues</div>
                        <div class="col-3 text-center">% Compl.</div>
                        <div class="col-6 text-center">Actions</div>
                      </div>
                    </div>
                  </div>
                  <div class="row py-1" v-for="proj in projects" :key="proj.id">
                    <div class="col-3">
                      <div class="row">
                        <div class="col-3 text-center">{{proj.id}}</div>
                        <div class="col-3 text-center">{{proj.facilityCode}}</div>
                        <div class="col-6 text-center">{{proj.projectType}}</div>
                      </div>
                    </div>
                    <div class="col-6">
                      <router-link :to="{ name: 'project', params: { projectId: proj.id }}" class="">{{proj.name}}</router-link>
                    </div>
                    <div class="col">
                      <div class="row">
                        <div class="col-3 p0 m0 text-center">{{proj.unresolvedIssues}}</div>
                        <div class="col-3 p0 m0 text-center">{{proj.progress}}%</div>
                        <div class="col-6 p0 m0 text-center" v-if="isAdmin">
                          <b-button class="btn-remove-project mr-2" variant="outline-secondary" size="sm" @click="lockProject(proj, !proj.readonly)">
                            <LockOpenVariantIcon v-if="proj.readonly" title="Unlock Project" />
                            <LockIcon v-else title="Lock Project" />
                          </b-button>
                          <b-button class="btn-remove-project m-0" variant="outline-warning" size="sm" @click="archiveProject(proj, !proj.archived)">
                            <ArchiveArrowUpIcon v-if="proj.archived" title="Unarchive Project" />
                            <ArchiveIcon v-else title="Archive Project" />
                          </b-button>
                        </div>
                        <div class="col text-right" v-else></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="empty-card text-center" v-else>
                  <h4> No {{ showArchived ? 'Archived' : 'Active' }} Projects</h4>
                  <a href="#" v-if="searchQuery" @click.prevent="searchQuery=''">clear project filter</a>
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </div>



    <b-modal title="New Project From Template"
             centered
             ref="projectModalRef"
             size="md"
             v-model="addProjDialog.visible">
      
      <div class="container" v-if="addProjDialog.visible">
        <div class="row">
          <div class="col-4">
            Project Type:
          </div>
          <div class="col-8">
            <b-form-select v-model="newProjectType">
              <template #first>
                <b-form-select-option :value="null" disabled>Select Project Template</b-form-select-option>
              </template>
              <b-form-select-option value="simple">Simple</b-form-select-option>
              <b-form-select-option value="engineering">Engineering</b-form-select-option>
              <b-form-select-option value="machining">Machining</b-form-select-option>
              <b-form-select-option value="moldMaking">Mold Making</b-form-select-option>
            </b-form-select>
          </div>
        </div>
        <b-overlay :show="!addProjDialog.templatesLoaded" rounded="lg">
          <template v-if="projectTemplates && projectTemplates.length">
            <div class="row">
              <div class="col-4">
                Template:
              </div>
              <div class="col-8">
                <b-form-select v-model="addProjDialog.selectedTemplateId"
                               :options="projectTemplates"
                               text-field="name"
                               value-field="id"
                               :options-field='null'>
                  <template #first>
                    <b-form-select-option :value="null" disabled>Select Project Template</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="row">
              
              <div class="col-4" v-if="this.newJobChecklist">Job #:</div>
              <div class="col-4" v-else>Name:</div>
              <div class="col-8">
                <input class="form-control mb-1" ref="newProjName" type="text" v-model.trim="newProjectName">
                <div style="font-size: x-small; font-weight:bold; color: red" v-if="newProjectName && newJobChecklist && !validProjectName">Invalid Job#, enter full job # i.e. 7100-C or C5000 or 16880</div>
                <div style="font-size: x-small; font-weight:bold; color: red" v-if="newProjectName && exactMatch">Duplicate Project name. Must be unique (add -1, 2, etc.)</div>

                
              </div>
            </div>
            <div class="row" v-if="similarProjects && similarProjects.length">
              <div class="col-12 mt-2 py-1 text-center" style="font-size: small; font-weight:bold; background-color: #fcc85d; color: #444">Similar checklist project(s) already exist! Use one of these?</div>
              <div class="col-4" v-for="proj in similarProjects" :key="proj.id">
                <router-link :to="{ name: 'project', params: { projectId: proj.id }}" class="small">{{proj.name}}</router-link>
              </div>
              
            </div>


          </template>
          <div v-else class="row">
            <div class="col-12 text-center my-3">
              <h4>No project templates defined</h4>
              <h6>Facility: {{selectedFacility}} Type: {{newProjectType}} </h6>
            </div>
          </div>
        </b-overlay>
        <!-- <div class="row">
    <div class="col-4">
      Description:
    </div>
    <div class="col-8">
      <b-form-textarea
        id="textarea-small"
        class="form-control"
        size="sm"
        placeholder="Project Description"
        v-model="selectedProject.description"
      ></b-form-textarea>
    </div>
  </div> -->
      </div>
      
      <template v-slot:modal-footer="{ cancel }">
        <b-button size="sm" variant="primary" @click="saveProjectTemplate()" :disabled="!canAddNewProject">Add</b-button>
        <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import Vue from "vue";
  import { Vuex, mapGetters, mapState, mapMutations } from "vuex";
  import axios from "axios";

  import { ChecklistProjectDto, ChecklistType, Client, Operation, ChecklistProjectType } from "../code/EngineeringChecklist.Api"
  import PlusBoxIcon from 'vue-material-design-icons/PlusBox.vue';
  import TrashCanIcon from 'vue-material-design-icons/TrashCan.vue';
  import ArchiveIcon from 'vue-material-design-icons/Archive.vue';
  import ArchiveArrowUpIcon from 'vue-material-design-icons/ArchiveArrowUp.vue';

  import LockIcon from 'vue-material-design-icons/Lock.vue';
  import LockOpenVariantIcon from 'vue-material-design-icons/LockOpenVariant.vue';
  const PROJECT_TYPE = 'projectType'

  export default Vue.extend({
    name: "ActiveProjects",
    components: {
      PlusBoxIcon,
      ArchiveIcon, ArchiveArrowUpIcon,
      LockIcon, LockOpenVariantIcon,
      // TrashCanIcon
    },
    data() {
      return {
        searchQuery: null,
        projectType: null,
        showArchived: false,
        projectTemplates: [],
        projects: [],
        similarProjects: null,
        createSimilar: false,
        newProjectType: null,
        addProjDialog: {
          visible: false,
          templatesLoaded: false,
          selectedTemplateId: null,
          newName: ''
        },


        loading: {
          facilities: true,
          projects: true,
          standard: true,
          mechanisms: true,
          newProjects: false
        },
        standardChecklists: [],
        mechanismChecklists: [],
        selectedProject: null,
      };
    },
    computed: {
      ...mapState(['selectedFacility']),
      ...mapGetters('context', ['isAdmin']),
      ...mapGetters(['activeFacilities']),
      projectTypeVal: {
        get: function () {
          return this.projectType;
        },
        set: function (newValue) {
          this.projectType = newValue;
          
        }
      },
      newProjectName: {
        get: function () {
          return this.addProjDialog.newName;
        },
        set: function (newValue) {
          if ( this.newJobChecklist && newValue) {
            this.addProjDialog.newName = String(newValue).toUpperCase();
          } else {
            this.addProjDialog.newName = newValue;
          }
        }
      },
      newJobChecklist: function () {
        return this.newProjectType != ChecklistProjectType.Simple;
      },
      validProjectName: function () {
        let val = false
        if (this.newJobChecklist) {
          //Job based checklist
          let m = /(\d{4,}-[A-Z]|[A-Z]\d{4,}|\d{5,})/gi
          //let m = /\d{4,}/gi
          val = m.test(this.newProjectName);
        } else {
          val = true
        }

        //Search for similar jobs
        if (val && this.newProjectName && this.newProjectName.length > 3) {
          this.debouncedSearchProjects(this.newProjectName);
        }

        return val;
      },
      exactMatch: function () {
        return !!_.find(this.similarProjects, { name: this.newProjectName });
      },
      canAddNewProject: function () {
        return this.projectTemplates &&
          this.projectTemplates.length &&
          this.addProjDialog.selectedTemplateId &&
          this.addProjDialog.newName &&
          this.validProjectName &&
          !!this.similarProjects &&
          !this.loading.newProjects &&
          !this.exactMatch;
      }
    },
    created() {
      this.projectType = window.localStorage.getItem(PROJECT_TYPE);

      this.debouncedfetchProjects = _.debounce(this.fetchProjects, 1000, {
        leading: false,
        trailing: true
      });

      this.debouncedSearchProjects = _.debounce(this.searchProjects, 1000, {
        leading: false,
        trailing: true
      });

      this.loading.projects = true;
      this.debouncedfetchProjects();

    },
    watch: {
      newProjectType: function (newValue, oldValue) {
        if (newValue) {
          this.loadProjectTemplates();
        } else {
          this.projectTemplates = [];
        }
      },
      validProjectName: function () {
        //
      },
      projectType: function (newValue, oldValue) {
        window.localStorage.setItem(PROJECT_TYPE, String(newValue));
        this.loading.projects = true;
        this.debouncedfetchProjects();
      },
      showArchived: function () {
        this.loading.projects = true;
        this.debouncedfetchProjects();
      },
      searchQuery: function () {
        this.loading.projects = true;
        this.debouncedfetchProjects();
      },
      selectedFacility: function () {
        this.loading.projects = true;
        this.debouncedfetchProjects();
      },
    },
    methods: {
      remove(array, item) {
        let index = array.indexOf(item);
        if (index >= 0) {
          array.splice(index, 1);
        }
      },
      newProject() {
        //If a type is selected, pre-select it in the add dialog
        if (this.projectType) {
          this.newProjectType = this.projectType;
        } else {
          this.newProjectType = null;
        }

        this.similarProjects = null;
        this.addProjDialog.selectedTemplateId = null;
        this.addProjDialog.newName = "";

        if (!this.addProjDialog.templatesLoaded) {
          this.loadProjectTemplates()
        } else if (this.projectTemplates && this.projectTemplates.length == 1) {
          this.addProjDialog.selectedTemplateId = this.projectTemplates[0].id;
        }

        this.addProjDialog.visible = true;
      },
      saveProjectTemplate: function () {
        if (this.addProjDialog.selectedTemplateId) {

          this.addProjDialog.visible = false;

          var c = new Client(process.env.VUE_APP_API_URL, this.$http);
          c.checklistProjects_CloneTemplate(
            this.addProjDialog.selectedTemplateId, this.addProjDialog.newName, false, this.selectedFacility, this.newProjectType)
            .then((newProject) => {

              //this.projects.push(newProject);
              //{ name: 'project', params: { projectId: proj.id } }
              this.$router.push({ name: 'project', params: { projectId: newProject.id } })

            })
            .catch((error) => {
              console.log(error);
            });

        }

      },
      loadProjectTemplates() {
        this.addProjDialog.templatesLoaded = false;
        var c = new Client(process.env.VUE_APP_API_URL, this.$http);

        return c.checklistProjects_GetAll(null, true, false, this.selectedFacility, this.newProjectType)
          .then((data) => {

            this.projectTemplates = data;
            this.addProjDialog.templatesLoaded = true;

            //If only one template select it...
            if (this.projectTemplates && this.projectTemplates.length == 1) {
              this.addProjDialog.selectedTemplateId = this.projectTemplates[0].id;

              setTimeout(() => { this.$refs['newProjName'].focus(); }, 250);
              //this.$nextTick(() => { });              
            }

            return data;
          })
          .catch((error) => {
            console.log(error);
          })
      },
      searchProjects(projectName) {

        // http://localhost:5000/api/ChecklistProjects?search=7153-C&template=false&archived=false&facilityCode=SY02M&projectType=machining
        var c = new Client(process.env.VUE_APP_API_URL, this.$http);

        c.checklistProjects_GetAll(projectName, false, false, this.selectedFacility, this.newProjectType)
          .then(function (data) {
            this.similarProjects = data;
          }.bind(this))
          .catch(error => {
            console.log(error.response);
          })
          .finally(
            function () {

              this.$nextTick(() => { this.loading.newProjects = false; });
              //this.loading.newProjects = false;
              
            }.bind(this)
          );
      },
      showSelectedProject(project) {
        if (!project) {
          this.selectedProject = new ChecklistProjectDto({ id: 0, isTemplate: true });
        } else {
          this.selectedProject = project;
        }

        this.$refs.projectModalRef.show();
      },
      patchProject: function (project, patch) {
        if (!project || !project.id) {
          console.log('Invalid project, cannot be patched');
          return;
        }
        var c = new Client(process.env.VUE_APP_API_URL, this.$http);

        var patches = [
          patch
          // new Operation({op: 'replace', path: '/progress', value: Math.round((status.accepted / status.count) * 100) }),
          // new Operation({op: 'replace', path: '/unresolvedIssues', value: status.issue})
        ]
        return c.checklistProjects_Patch(project.id, patches)
          .catch((error) => {
            console.log(error);
          })
      },
      lockProject(project, locked) {

        this.$bvModal.msgBoxConfirm(`Are you sure you want to ${locked ? 'lock' : 'unlock'} project ${project.name}?`, {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'warning',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(function (value) {

          if (value) {
            this.patchProject(project, new Operation({ op: 'replace', path: '/readonly', value: !!locked }))
              .then(function () {
                project.readonly = !!locked;
                this.$bvToast.toast(`Sucessfully ${locked ? 'locked' : 'unlocked'} project: "${project.name}"`, {
                  title: `Project ${archived ? 'Locked' : 'Unlocked'}.`,
                  variant: "success"
                });

              }.bind(this));
          }
        }.bind(this))
      },
      archiveProject(project, archived) {

        this.$bvModal.msgBoxConfirm(`Are you sure you want to ${archived ? 'archive' : 'unarchive'} project ${project.name}?`, {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'warning',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(function (value) {

          if (value) {
            this.patchProject(project, new Operation({ op: 'replace', path: '/archived', value: !!archived }))
              .then(function () {
                this.$bvToast.toast(`Sucessfully ${archived ? 'archived' : 'unarchived'} project: "${project.name}"`, {
                  title: `Project ${archived ? 'Archived' : 'Unarchived'}.`,
                  variant: "success"
                });

                this.remove(this.projects, project);
              }.bind(this));
          }
        }.bind(this))


      },
      fetchProjects() {
        var c = new Client(process.env.VUE_APP_API_URL, this.$http);

        this.loading.projects = true;

        c.checklistProjects_GetAll(this.searchQuery, false, this.showArchived, this.selectedFacility, this.projectType)
          .then(function (data) {
            this.projects = data;
          }.bind(this))
          .catch(error => {
            console.log(error.response);
          })
          .finally(
            function () {
              this.loading.projects = false;
            }.bind(this)
          );
      },
    }

  });
</script>

<style>
</style>